import { Typography, TypographyProps } from "@mui/material";
import { ReactNode } from "react";

interface TruncatedTextProps extends Omit<TypographyProps, "children"> {
  children: ReactNode;
  lines?: number;
  width?: string | number;
  showTooltip?: boolean;
}

/**
 * A reusable component for text truncation that automatically handles minWidth: 0
 * and provides consistent ellipsis behavior.
 */
export default function TruncatedText({
  children,
  lines = 1,
  width = "100%",
  showTooltip = false,
  sx,
  ...props
}: TruncatedTextProps) {
  const isMultiLine = lines > 1;

  const truncationStyles = isMultiLine
    ? {
        display: "-webkit-box",
        WebkitLineClamp: lines,
        WebkitBoxOrient: "vertical" as const,
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        width,
      }
    : {
        whiteSpace: "nowrap" as const,
        overflow: "hidden",
        textOverflow: "ellipsis",
        minWidth: 0,
        width,
      };

  return (
    <Typography
      {...props}
      sx={{
        ...truncationStyles,
        ...sx,
      }}
      title={showTooltip ? String(children) : undefined}
    >
      {children}
    </Typography>
  );
}
